/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CompleteDeliveryNotePreview,
  CreateDeliveryNote,
  CustomCreateDeliveryNote,
  DeliveryNote,
  DeliveryNoteList,
  DocumentVersion,
  DocumentVersionList,
  Error,
  GetDeliveryNoteByIdParams,
  GetDeliveryNotesParams,
  GetShareableDeliveryNoteHtmlParams,
  GetShareableDeliveryNotePdfParams,
  PartialDeliveryNotePreview,
  RenderDeliveryNotePreviewParams,
  UpdateDeliveryNote,
  ValidationError,
  VoidDeliveryNoteBody
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve delivery note data using a shareable token. No authentication required. Returns full delivery note data for rendering.
 * @summary View shareable delivery note
 */
export type getShareableDeliveryNoteResponse200 = {
  data: DeliveryNote
  status: 200
}

export type getShareableDeliveryNoteResponse404 = {
  data: void
  status: 404
}

export type getShareableDeliveryNoteResponseSuccess = (getShareableDeliveryNoteResponse200) & {
  headers: Headers;
};
export type getShareableDeliveryNoteResponseError = (getShareableDeliveryNoteResponse404) & {
  headers: Headers;
};

export type getShareableDeliveryNoteResponse = (getShareableDeliveryNoteResponseSuccess | getShareableDeliveryNoteResponseError)

export const getGetShareableDeliveryNoteUrl = (shareableId: string,) => {


  

  return `/delivery-notes/shareable/${shareableId}`
}

export const getShareableDeliveryNote = async (shareableId: string, options?: RequestInit): Promise<getShareableDeliveryNoteResponse> => {
  
  return customFetch<getShareableDeliveryNoteResponse>(getGetShareableDeliveryNoteUrl(shareableId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Get delivery note as HTML preview using a shareable token. No authentication required. Supports multiple languages via locale query parameter.
 * @summary Get shareable delivery note as HTML
 */
export type getShareableDeliveryNoteHtmlResponse200 = {
  data: string
  status: 200
}

export type getShareableDeliveryNoteHtmlResponse404 = {
  data: void
  status: 404
}

export type getShareableDeliveryNoteHtmlResponseSuccess = (getShareableDeliveryNoteHtmlResponse200) & {
  headers: Headers;
};
export type getShareableDeliveryNoteHtmlResponseError = (getShareableDeliveryNoteHtmlResponse404) & {
  headers: Headers;
};

export type getShareableDeliveryNoteHtmlResponse = (getShareableDeliveryNoteHtmlResponseSuccess | getShareableDeliveryNoteHtmlResponseError)

export const getGetShareableDeliveryNoteHtmlUrl = (shareableId: string,
    params?: GetShareableDeliveryNoteHtmlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/delivery-notes/shareable/${shareableId}/html?${stringifiedParams}` : `/delivery-notes/shareable/${shareableId}/html`
}

export const getShareableDeliveryNoteHtml = async (shareableId: string,
    params?: GetShareableDeliveryNoteHtmlParams, options?: RequestInit): Promise<getShareableDeliveryNoteHtmlResponse> => {
  
  return customFetch<getShareableDeliveryNoteHtmlResponse>(getGetShareableDeliveryNoteHtmlUrl(shareableId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Download delivery note as PDF using a shareable token. No authentication required. Supports multiple languages via locale query parameter.
 * @summary Download shareable delivery note as PDF
 */
export type getShareableDeliveryNotePdfResponse200 = {
  data: Blob
  status: 200
}

export type getShareableDeliveryNotePdfResponse404 = {
  data: void
  status: 404
}

export type getShareableDeliveryNotePdfResponseSuccess = (getShareableDeliveryNotePdfResponse200) & {
  headers: Headers;
};
export type getShareableDeliveryNotePdfResponseError = (getShareableDeliveryNotePdfResponse404) & {
  headers: Headers;
};

export type getShareableDeliveryNotePdfResponse = (getShareableDeliveryNotePdfResponseSuccess | getShareableDeliveryNotePdfResponseError)

export const getGetShareableDeliveryNotePdfUrl = (shareableId: string,
    params?: GetShareableDeliveryNotePdfParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/delivery-notes/shareable/${shareableId}/pdf?${stringifiedParams}` : `/delivery-notes/shareable/${shareableId}/pdf`
}

export const getShareableDeliveryNotePdf = async (shareableId: string,
    params?: GetShareableDeliveryNotePdfParams, options?: RequestInit): Promise<getShareableDeliveryNotePdfResponse> => {
  
  return customFetch<getShareableDeliveryNotePdfResponse>(getGetShareableDeliveryNotePdfUrl(shareableId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create a new delivery note with line items.
Customer is optional - can be omitted or added inline without referencing a customer_id.
The delivery note number is auto-generated based on the entity's number format settings.
Taxes are calculated automatically based on the tax rates provided.
Set hide_prices=true to create a packing list without prices.
 * @summary Create a new delivery note
 */
export type createDeliveryNoteResponse201 = {
  data: DeliveryNote
  status: 201
}

export type createDeliveryNoteResponse400 = {
  data: Error
  status: 400
}

export type createDeliveryNoteResponse401 = {
  data: Error
  status: 401
}

export type createDeliveryNoteResponse403 = {
  data: Error
  status: 403
}

export type createDeliveryNoteResponse404 = {
  data: Error
  status: 404
}

export type createDeliveryNoteResponse422 = {
  data: ValidationError
  status: 422
}

export type createDeliveryNoteResponse500 = {
  data: Error
  status: 500
}

export type createDeliveryNoteResponseSuccess = (createDeliveryNoteResponse201) & {
  headers: Headers;
};
export type createDeliveryNoteResponseError = (createDeliveryNoteResponse400 | createDeliveryNoteResponse401 | createDeliveryNoteResponse403 | createDeliveryNoteResponse404 | createDeliveryNoteResponse422 | createDeliveryNoteResponse500) & {
  headers: Headers;
};

export type createDeliveryNoteResponse = (createDeliveryNoteResponseSuccess | createDeliveryNoteResponseError)

export const getCreateDeliveryNoteUrl = () => {


  

  return `/delivery-notes`
}

export const createDeliveryNote = async (createDeliveryNote: CreateDeliveryNote, options?: RequestInit): Promise<createDeliveryNoteResponse> => {
  
  return customFetch<createDeliveryNoteResponse>(getCreateDeliveryNoteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDeliveryNote,)
  }
);}
  

/**
 * Retrieve a paginated list of delivery notes with optional filtering and sorting.
Supports cursor-based pagination, flexible JSON querying with MongoDB-style operators, full-text search, and sorting.
 * @summary List all delivery notes
 */
export type getDeliveryNotesResponse200 = {
  data: DeliveryNoteList
  status: 200
}

export type getDeliveryNotesResponse400 = {
  data: Error
  status: 400
}

export type getDeliveryNotesResponse401 = {
  data: Error
  status: 401
}

export type getDeliveryNotesResponse403 = {
  data: Error
  status: 403
}

export type getDeliveryNotesResponse404 = {
  data: Error
  status: 404
}

export type getDeliveryNotesResponse500 = {
  data: Error
  status: 500
}

export type getDeliveryNotesResponseSuccess = (getDeliveryNotesResponse200) & {
  headers: Headers;
};
export type getDeliveryNotesResponseError = (getDeliveryNotesResponse400 | getDeliveryNotesResponse401 | getDeliveryNotesResponse403 | getDeliveryNotesResponse404 | getDeliveryNotesResponse500) & {
  headers: Headers;
};

export type getDeliveryNotesResponse = (getDeliveryNotesResponseSuccess | getDeliveryNotesResponseError)

export const getGetDeliveryNotesUrl = (params?: GetDeliveryNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/delivery-notes?${stringifiedParams}` : `/delivery-notes`
}

export const getDeliveryNotes = async (params?: GetDeliveryNotesParams, options?: RequestInit): Promise<getDeliveryNotesResponse> => {
  
  return customFetch<getDeliveryNotesResponse>(getGetDeliveryNotesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create a delivery note with pre-calculated totals from an external system.
The caller provides `total`, `total_with_tax`, `total_discount`, and `taxes` at the document level, and `total`/`total_with_tax` on each line item.
When `calculation_mode` is omitted, Space Invoices preserves pass-through behavior and accepts the supplied totals as-is.
When `calculation_mode` is provided, Space Invoices validates the supplied totals against that calculation mode before creating the document.
All other logic (numbering, customer handling, lifecycle hooks) is identical to the standard create endpoint.
 * @summary Create delivery note with pre-calculated totals
 */
export type createCustomDeliveryNoteResponse201 = {
  data: DeliveryNote
  status: 201
}

export type createCustomDeliveryNoteResponse400 = {
  data: Error
  status: 400
}

export type createCustomDeliveryNoteResponse401 = {
  data: Error
  status: 401
}

export type createCustomDeliveryNoteResponse403 = {
  data: Error
  status: 403
}

export type createCustomDeliveryNoteResponse404 = {
  data: Error
  status: 404
}

export type createCustomDeliveryNoteResponse422 = {
  data: ValidationError
  status: 422
}

export type createCustomDeliveryNoteResponse500 = {
  data: Error
  status: 500
}

export type createCustomDeliveryNoteResponseSuccess = (createCustomDeliveryNoteResponse201) & {
  headers: Headers;
};
export type createCustomDeliveryNoteResponseError = (createCustomDeliveryNoteResponse400 | createCustomDeliveryNoteResponse401 | createCustomDeliveryNoteResponse403 | createCustomDeliveryNoteResponse404 | createCustomDeliveryNoteResponse422 | createCustomDeliveryNoteResponse500) & {
  headers: Headers;
};

export type createCustomDeliveryNoteResponse = (createCustomDeliveryNoteResponseSuccess | createCustomDeliveryNoteResponseError)

export const getCreateCustomDeliveryNoteUrl = () => {


  

  return `/delivery-notes/custom`
}

export const createCustomDeliveryNote = async (customCreateDeliveryNote: CustomCreateDeliveryNote, options?: RequestInit): Promise<createCustomDeliveryNoteResponse> => {
  
  return customFetch<createCustomDeliveryNoteResponse>(getCreateCustomDeliveryNoteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customCreateDeliveryNote,)
  }
);}
  

/**
 * Retrieve a single delivery note by its unique identifier. Returns the complete delivery note details including all line items, customer information, and calculated totals.
 * @summary Get delivery note by ID
 */
export type getDeliveryNoteByIdResponse200 = {
  data: DeliveryNote
  status: 200
}

export type getDeliveryNoteByIdResponse401 = {
  data: Error
  status: 401
}

export type getDeliveryNoteByIdResponse403 = {
  data: Error
  status: 403
}

export type getDeliveryNoteByIdResponse404 = {
  data: Error
  status: 404
}

export type getDeliveryNoteByIdResponse500 = {
  data: Error
  status: 500
}

export type getDeliveryNoteByIdResponseSuccess = (getDeliveryNoteByIdResponse200) & {
  headers: Headers;
};
export type getDeliveryNoteByIdResponseError = (getDeliveryNoteByIdResponse401 | getDeliveryNoteByIdResponse403 | getDeliveryNoteByIdResponse404 | getDeliveryNoteByIdResponse500) & {
  headers: Headers;
};

export type getDeliveryNoteByIdResponse = (getDeliveryNoteByIdResponseSuccess | getDeliveryNoteByIdResponseError)

export const getGetDeliveryNoteByIdUrl = (id: string,
    params?: GetDeliveryNoteByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/delivery-notes/${id}?${stringifiedParams}` : `/delivery-notes/${id}`
}

export const getDeliveryNoteById = async (id: string,
    params?: GetDeliveryNoteByIdParams, options?: RequestInit): Promise<getDeliveryNoteByIdResponse> => {
  
  return customFetch<getDeliveryNoteByIdResponse>(getGetDeliveryNoteByIdUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing delivery note.
Creates a version snapshot before applying changes.
Cannot update voided delivery notes.
If items are provided, they replace all existing items.
 * @summary Update a delivery note
 */
export type updateDeliveryNoteResponse200 = {
  data: DeliveryNote
  status: 200
}

export type updateDeliveryNoteResponse400 = {
  data: Error
  status: 400
}

export type updateDeliveryNoteResponse401 = {
  data: Error
  status: 401
}

export type updateDeliveryNoteResponse403 = {
  data: Error
  status: 403
}

export type updateDeliveryNoteResponse404 = {
  data: Error
  status: 404
}

export type updateDeliveryNoteResponse422 = {
  data: ValidationError
  status: 422
}

export type updateDeliveryNoteResponse500 = {
  data: Error
  status: 500
}

export type updateDeliveryNoteResponseSuccess = (updateDeliveryNoteResponse200) & {
  headers: Headers;
};
export type updateDeliveryNoteResponseError = (updateDeliveryNoteResponse400 | updateDeliveryNoteResponse401 | updateDeliveryNoteResponse403 | updateDeliveryNoteResponse404 | updateDeliveryNoteResponse422 | updateDeliveryNoteResponse500) & {
  headers: Headers;
};

export type updateDeliveryNoteResponse = (updateDeliveryNoteResponseSuccess | updateDeliveryNoteResponseError)

export const getUpdateDeliveryNoteUrl = (id: string,) => {


  

  return `/delivery-notes/${id}`
}

export const updateDeliveryNote = async (id: string,
    updateDeliveryNote: UpdateDeliveryNote, options?: RequestInit): Promise<updateDeliveryNoteResponse> => {
  
  return customFetch<updateDeliveryNoteResponse>(getUpdateDeliveryNoteUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDeliveryNote,)
  }
);}
  

/**
 * Retrieve the version history for a delivery note. Each version represents the document state before an update was applied.
 * @summary Get delivery note version history
 */
export type getDeliveryNoteVersionsResponse200 = {
  data: DocumentVersionList
  status: 200
}

export type getDeliveryNoteVersionsResponse401 = {
  data: Error
  status: 401
}

export type getDeliveryNoteVersionsResponse403 = {
  data: Error
  status: 403
}

export type getDeliveryNoteVersionsResponse404 = {
  data: Error
  status: 404
}

export type getDeliveryNoteVersionsResponse500 = {
  data: Error
  status: 500
}

export type getDeliveryNoteVersionsResponseSuccess = (getDeliveryNoteVersionsResponse200) & {
  headers: Headers;
};
export type getDeliveryNoteVersionsResponseError = (getDeliveryNoteVersionsResponse401 | getDeliveryNoteVersionsResponse403 | getDeliveryNoteVersionsResponse404 | getDeliveryNoteVersionsResponse500) & {
  headers: Headers;
};

export type getDeliveryNoteVersionsResponse = (getDeliveryNoteVersionsResponseSuccess | getDeliveryNoteVersionsResponseError)

export const getGetDeliveryNoteVersionsUrl = (id: string,) => {


  

  return `/delivery-notes/${id}/versions`
}

export const getDeliveryNoteVersions = async (id: string, options?: RequestInit): Promise<getDeliveryNoteVersionsResponse> => {
  
  return customFetch<getDeliveryNoteVersionsResponse>(getGetDeliveryNoteVersionsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a specific version snapshot of a delivery note.
 * @summary Get specific delivery note version
 */
export type getDeliveryNoteVersionResponse200 = {
  data: DocumentVersion
  status: 200
}

export type getDeliveryNoteVersionResponse401 = {
  data: Error
  status: 401
}

export type getDeliveryNoteVersionResponse403 = {
  data: Error
  status: 403
}

export type getDeliveryNoteVersionResponse404 = {
  data: Error
  status: 404
}

export type getDeliveryNoteVersionResponse500 = {
  data: Error
  status: 500
}

export type getDeliveryNoteVersionResponseSuccess = (getDeliveryNoteVersionResponse200) & {
  headers: Headers;
};
export type getDeliveryNoteVersionResponseError = (getDeliveryNoteVersionResponse401 | getDeliveryNoteVersionResponse403 | getDeliveryNoteVersionResponse404 | getDeliveryNoteVersionResponse500) & {
  headers: Headers;
};

export type getDeliveryNoteVersionResponse = (getDeliveryNoteVersionResponseSuccess | getDeliveryNoteVersionResponseError)

export const getGetDeliveryNoteVersionUrl = (id: string,
    version: number,) => {


  

  return `/delivery-notes/${id}/versions/${version}`
}

export const getDeliveryNoteVersion = async (id: string,
    version: number, options?: RequestInit): Promise<getDeliveryNoteVersionResponse> => {
  
  return customFetch<getDeliveryNoteVersionResponse>(getGetDeliveryNoteVersionUrl(id,version),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Render an HTML preview of a delivery note without saving to the database. Perfect for displaying live previews in delivery note creation/edit forms. Supports both partial mode (allows incomplete data for drafts) and complete mode (validates all required fields).
 * @summary Render delivery note preview
 */
export type renderDeliveryNotePreviewResponse200 = {
  data: string
  status: 200
}

export type renderDeliveryNotePreviewResponse400 = {
  data: Error
  status: 400
}

export type renderDeliveryNotePreviewResponse401 = {
  data: Error
  status: 401
}

export type renderDeliveryNotePreviewResponse403 = {
  data: Error
  status: 403
}

export type renderDeliveryNotePreviewResponse404 = {
  data: Error
  status: 404
}

export type renderDeliveryNotePreviewResponse422 = {
  data: ValidationError
  status: 422
}

export type renderDeliveryNotePreviewResponse500 = {
  data: Error
  status: 500
}

export type renderDeliveryNotePreviewResponseSuccess = (renderDeliveryNotePreviewResponse200) & {
  headers: Headers;
};
export type renderDeliveryNotePreviewResponseError = (renderDeliveryNotePreviewResponse400 | renderDeliveryNotePreviewResponse401 | renderDeliveryNotePreviewResponse403 | renderDeliveryNotePreviewResponse404 | renderDeliveryNotePreviewResponse422 | renderDeliveryNotePreviewResponse500) & {
  headers: Headers;
};

export type renderDeliveryNotePreviewResponse = (renderDeliveryNotePreviewResponseSuccess | renderDeliveryNotePreviewResponseError)

export const getRenderDeliveryNotePreviewUrl = (params?: RenderDeliveryNotePreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/delivery-notes/render?${stringifiedParams}` : `/delivery-notes/render`
}

export const renderDeliveryNotePreview = async (partialDeliveryNotePreviewCompleteDeliveryNotePreview: PartialDeliveryNotePreview | CompleteDeliveryNotePreview,
    params?: RenderDeliveryNotePreviewParams, options?: RequestInit): Promise<renderDeliveryNotePreviewResponse> => {
  
  return customFetch<renderDeliveryNotePreviewResponse>(getRenderDeliveryNotePreviewUrl(params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partialDeliveryNotePreviewCompleteDeliveryNotePreview,)
  }
);}
  

/**
 * Void a delivery note for technical reasons (duplicate, error, etc.). Voiding marks the delivery note as invalid and prevents further modifications.
 * @summary Void a delivery note
 */
export type voidDeliveryNoteResponse200 = {
  data: DeliveryNote
  status: 200
}

export type voidDeliveryNoteResponse400 = {
  data: Error
  status: 400
}

export type voidDeliveryNoteResponse401 = {
  data: Error
  status: 401
}

export type voidDeliveryNoteResponse403 = {
  data: Error
  status: 403
}

export type voidDeliveryNoteResponse404 = {
  data: Error
  status: 404
}

export type voidDeliveryNoteResponse422 = {
  data: ValidationError
  status: 422
}

export type voidDeliveryNoteResponse500 = {
  data: Error
  status: 500
}

export type voidDeliveryNoteResponseSuccess = (voidDeliveryNoteResponse200) & {
  headers: Headers;
};
export type voidDeliveryNoteResponseError = (voidDeliveryNoteResponse400 | voidDeliveryNoteResponse401 | voidDeliveryNoteResponse403 | voidDeliveryNoteResponse404 | voidDeliveryNoteResponse422 | voidDeliveryNoteResponse500) & {
  headers: Headers;
};

export type voidDeliveryNoteResponse = (voidDeliveryNoteResponseSuccess | voidDeliveryNoteResponseError)

export const getVoidDeliveryNoteUrl = (id: string,) => {


  

  return `/delivery-notes/${id}/void`
}

export const voidDeliveryNote = async (id: string,
    voidDeliveryNoteBody: VoidDeliveryNoteBody, options?: RequestInit): Promise<voidDeliveryNoteResponse> => {
  
  return customFetch<voidDeliveryNoteResponse>(getVoidDeliveryNoteUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voidDeliveryNoteBody,)
  }
);}
  

